import http from '@/utils/http'
import { logError } from '@/utils/logger'
import { ElMessage } from 'element-plus'

const initialState = () => ({
  list: [],
  jobId: null
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LISTS (state, list) {
    state.list = list
  },
  SET_JOB_ID (state, id = null) {
    state.jobId = id
  }
}

export const getters = {
  source: state => state.list.filter(param => param.IsSource),
  destination: state => state.list.filter(param => param.IsDestination),
  logic: state => state.list.filter(param => param.IsLogic),
  translations: state => state.list.filter(param => !!param.TranslationTableFormat),
  uncategorized: state => state.list.filter(param => (!param.IsSource && !param.IsDestination && !param.IsLogic))
}

export const actions = {
  fetchParameters ({ commit, rootGetters }, { jobId = null, force = false }) {
    if (state.jobId === jobId) {
      return true
    }

    if (jobId) {
      return http({
        url: `${process.env.VUE_APP_API_URL}job/parameters/${rootGetters['auth/token']}/${jobId}`
      }).then(data => {
        commit('RESET')
        commit('SET_LISTS', data)

        return data
      }).catch(e => {
        ElMessage.error('error loading job parameters')

        logError(e, { jobId }, 'job parameters: error loading job parameters')

        throw e
      })
    } else {
      commit('SET_LISTS', [])
    }
  },
  async saveDefaultParams ({ state, rootGetters }, { param, system, id }) {
    if (!param[`DataConnectorPlugin${system}`]) {
      return
    }

    const promises = []

    let list = []
    try {
      list = await http({
        url: `${process.env.VUE_APP_API_URL}dataconnector/parameters/${rootGetters['auth/token']}/${param[`DataConnectorPlugin${system}`]}`
      })
    } catch (e) {
      logError(e, { param, system, id }, 'job parameters: error loading default job parameters')

      throw e
    }

    const params = []
    for (const item of list) {
      params.push({
        JobID: id,
        DataConnectorName: param[`DataConnectorPlugin${system}`],
        IsSource: system === 'Source',
        IsDestination: system === 'Destination',
        Key: item.ParameterName,
        Value: ''
      })
    }

    if (params.length) {
      promises.push(http({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}job/parameters/${rootGetters['auth/token']}/${id}`,
        data: params
      }))
    }

    if (promises.length) {
      const results = await Promise.all(promises)

      for (const result of results) {
        if (!result) {
          return false
        }
      }
    }

    return true
  },
  async removeSavedParams ({ state, rootGetters, dispatch }, { param, system }) {
    if (!param.ID) {
      throw new Error('no job ID found to remove params')
    }

    const promises = []
    const params = state.parameters || await dispatch('fetchParameters', param.ID) || []

    for (const listItem of params) {
      if (listItem[`Is${system}`]) {
        promises.push(dispatch('removeParam', listItem))
      }
    }

    if (promises.length) {
      return Promise.all(promises)
    }
  },
  saveParam ({ state, rootGetters }, param) {
    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}job/parameter/${rootGetters['auth/token']}`,
      data: param
    })
  },
  removeParam ({ state, rootGetters }, param) {
    return http({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}job/parameter/delete/${rootGetters['auth/token']}`,
      data: param
    })
  }
}
